<template>
    <div class="about">
        <div class="pg-header">
            <div><label class="title">
                    {{ titleData[menuStatus] }}
                </label></div>
            <div class="algr">
                <div class="pg-nav">
                    <i class="icon-home"></i>
                    <span>院中管理</span>|
                    <template v-if="subMenu">
                        <span>{{ menuData[subMenu] }}</span>|
                    </template>
                    <span>
                        {{ titleData[menuStatus] }}
                    </span>
                </div>
            </div>
        </div>

        <div class="collapse-wrap" :class="{ active: isExpanded }">
            <div class="search-bar">
                <el-form ref="form" label-width="120px">
                    <div class="def-key">
                        <div>姓名<el-input size="small" maxlength="6" style="width:80px" v-model.trim="filter.name"
                                @keyup.enter.native="handleFilter(0, $event)"></el-input></div>
                        <div>住院号<el-input size="small" maxlength="18" style="width:80px"
                                v-model.trim="filter.admissionNumber"
                                @keyup.enter.native="handleFilter(1, $event)"></el-input></div>
                        <div>身份证号<el-input size="small" maxlength="18" style="width:180px" v-model.trim="filter.cardNum"
                                @keyup.enter.native="handleFilter(1, $event)"></el-input></div>
                        <div>入院诊断<el-input size="small" style="width:100px" v-model.trim="filter.inHospitalDiagnosis"
                                @keyup.enter.native="handleFilter(4, $event)"></el-input></div>
                        <div>科室
                            <el-select size="small" filterable clearable placeholder="请选择"
                                v-model="filter.inHospitalDepartmentId" @change="handleFilter(2, $event)">
                                <el-option v-for="item in deptList" :key="item.id" :label="item.name"
                                    :value="item.id"></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="def-key">
                        <div>入院时间
                            <el-date-picker size="small" :default-time="['00:00:00', '23:59:59']" style="width:220px"
                                type="daterange" align="right" unlink-panels range-separator="至"
                                start-placeholder="开始日期" end-placeholder="结束日期" v-model="filter.inDate"
                                :picker-options="pickerOptions"
                                @change="handleFilter('inDate', $event)"></el-date-picker>
                        </div>
                        <div v-if="menuStatus == 3 || menuStatus == 2 || subMenu == 1 || subMenu == 2 || subMenu == 3">
                            分配时间
                            <el-date-picker size="small" :default-time="['00:00:00', '23:59:59']" style="width:220px"
                                type="daterange" align="right" unlink-panels range-separator="至"
                                start-placeholder="开始日期" end-placeholder="结束日期" v-model="filter.manageDate"
                                :picker-options="pickerOptions"
                                @change="handleFilter('manageDate', $event)"></el-date-picker>
                        </div>
                        <div v-if="menuStatus == 3">结束管理时间
                            <el-date-picker size="small" :default-time="['00:00:00', '23:59:59']" style="width:220px"
                                type="daterange" align="right" unlink-panels range-separator="至"
                                start-placeholder="开始日期" end-placeholder="结束日期" v-model="filter.finishDate"
                                :picker-options="pickerOptions"
                                @change="handleFilter('finishDate', $event)"></el-date-picker>
                        </div>
                        <div v-if="menuStatus == 5">勿访时间
                            <el-date-picker size="small" :default-time="['00:00:00', '23:59:59']" style="width:220px"
                                type="daterange" align="right" unlink-panels range-separator="至"
                                start-placeholder="开始日期" end-placeholder="结束日期" v-model="filter.dispenseDate"
                                :picker-options="pickerOptions"
                                @change="handleFilter('dispenseDate', $event)"></el-date-picker>
                        </div>
                        <div v-if="menuStatus != 1">出院日期
                            <el-date-picker size="small" :default-time="['00:00:00', '23:59:59']" style="width:220px"
                                type="daterange" align="right" unlink-panels range-separator="至"
                                start-placeholder="开始日期" end-placeholder="结束日期" v-model="filter.outDate"
                                :picker-options="pickerOptions"
                                @change="handleFilter('outDate', $event)"></el-date-picker>
                        </div>
                        <div v-if="menuStatus == 7">申请时间
                            <el-date-picker size="small" :default-time="['00:00:00', '23:59:59']" style="width:220px"
                                type="daterange" align="right" unlink-panels range-separator="至"
                                start-placeholder="开始日期" end-placeholder="结束日期" v-model="filter.applicationTime"
                                :picker-options="pickerOptions"
                                @change="handleFilter('applicationTime', $event)"></el-date-picker>
                        </div>
                        <div v-if="menuStatus == 9">发布时间
                            <el-date-picker size="small" :default-time="['00:00:00', '23:59:59']" style="width:220px"
                                type="daterange" align="right" unlink-panels range-separator="至"
                                start-placeholder="开始日期" end-placeholder="结束日期" v-model="filter.publishTime"
                                :picker-options="pickerOptions"
                                @change="handleFilter('publishTime', $event)"></el-date-picker>
                        </div>
                        <div v-if="menuStatus == 11">完成时间
                            <el-date-picker size="small" :default-time="['00:00:00', '23:59:59']" style="width:220px"
                                type="daterange" align="right" unlink-panels range-separator="至"
                                start-placeholder="开始日期" end-placeholder="结束日期" v-model="filter.eduTime"
                                :picker-options="pickerOptions"
                                @change="handleFilter('eduTime', $event)"></el-date-picker>
                        </div>
                        <div v-if="menuStatus == 1">疾病管理师
                            <el-select size="small" filterable clearable placeholder="请选择"
                                v-model="filter.diseaseManagerId" @change="handleFilter(3, $event)">
                                <el-option v-for="item in managerList" :key="item.id" :label="item.name"
                                    :value="item.id"></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="def-key">
                        <div v-if="menuStatus != 1 && menuStatus != 5 && menuStatus != 8 && menuStatus != 9">
                            疾病管理师
                            <el-select size="small" filterable clearable placeholder="请选择"
                                v-model="filter.diseaseManagerId" @change="handleFilter(3, $event)">
                                <el-option v-for="item in managerList" :key="item.id" :label="item.name"
                                    :value="item.id"></el-option>
                            </el-select>
                        </div>
                        <div v-if="menuStatus == 8 || menuStatus == 9">
                            责任医师
                            <el-select size="small" filterable clearable placeholder="请选择" v-model="filter.mainDoctorId"
                                @change="handleFilter(3, $event)">
                                <el-option v-for="item in mainList" :key="item.id" :label="item.name"
                                    :value="item.id"></el-option>
                            </el-select>
                        </div>
                        <div>排序条件
                            <el-select size="small" filterable clearable placeholder="请选择"
                                v-model="filter.orderCondition" @change="handleFilter(7, $event)">
                                <el-option v-for="item in orderConditionList" :key="item.id" :label="item.name"
                                    :value="item.id"></el-option>
                            </el-select>
                        </div>
                        <div>排序顺序
                            <el-select size="small" filterable clearable placeholder="请选择" v-model="filter.orderRule"
                                @change="handleFilter(6, $event)">
                                <el-option v-for="item in orderRuleList" :key="item.id" :label="item.name"
                                    :value="item.id"></el-option>
                            </el-select>
                        </div>
                        <el-button size="mini" class="flr" icon="el-icon-search" round
                            @click="handleFilter">搜索</el-button>
                        <el-button size="mini" class="flr"  round @click="exportReport">
                            <i class="icon-export" style="margin-left: 0; margin-right:5px;"></i>导出
                        </el-button>
                        <template v-if="subMenu == 2 || menuStatus == 7 || menuStatus == 3">
                            <el-button class="btn-collapse flr" size="mini" round @click="toggleCollapse"
                                v-if="!isExpanded">展开筛选<i class="icon-expand"></i></el-button>
                            <el-button class="btn-collapse flr" size="mini" round @click="toggleCollapse" v-else>收起筛选<i
                                    class="icon-collapse"></i></el-button>
                        </template>
                    </div>
                    <div class="more-key" v-if="subMenu == 2 || menuStatus == 7 || menuStatus == 3">
                        <el-alert title="高级筛选查询速度较慢，请耐心等待。" type="warning" show-icon :closable='false'></el-alert>
                        <div class="more-item">
                            <el-form-item v-for="(item, key) in selectData" :label="item.label" :key="key">
                                <template v-if="item.options.left && item.options.right">
                                    <el-select size="small" filterable clearable placeholder="请选择"
                                        v-model="filter[key + 'type']" @change="handleFilter(2, $event, key)">
                                        <el-option v-for="leftOption in item.options.left" :key="leftOption.id"
                                            :label="leftOption.name" :value="leftOption.id"></el-option>
                                    </el-select>
                                    <el-select size="small" filterable clearable placeholder="请选择"
                                        v-if="filter[key + 'type']" v-model="filter[key + 'level']"
                                        @change="handleFilter(2, $event, key)">
                                        <el-option v-for="rightOption in item.options.right[filter[key + 'type'] - 1]"
                                            :key="rightOption.id" :label="rightOption.name"
                                            :value="rightOption.id"></el-option>
                                    </el-select>
                                </template>
                                <template v-else>
                                    <el-select size="small" filterable clearable placeholder="请选择"
                                        v-model="filter[key + 'type']" @change="handleFilter(2, $event, key)">
                                        <el-option v-for="option in item.options" :key="option.id" :label="option.name"
                                            :value="option.id"></el-option>
                                    </el-select>
                                </template>
                            </el-form-item>

                            <el-form-item label="评估结果关系" style="margin-left: 26px;">
                                <el-radio-group v-model="filter.evalScoreTypeRelation" @change="handleFilter()">
                                    <el-radio :label="1">且</el-radio>
                                    <el-radio :label="2">或</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item class="reset">
                                <el-button type="primary" size="small" @click="resetForm">重置筛选条件</el-button>
                            </el-form-item>
                        </div>


                    </div>
                </el-form>
            </div>

            <div class="table-wrap" v-if="menuStatus">
                <div class="action-bar" v-if="menuStatus == 1">
                    <el-button type="primary" size="mini" round @click="showDlg">批量分配</el-button>
                    <el-popconfirm confirmButtonText='确定' title="确定勿访吗？" @confirm="saveForm2"
                        v-if="filter.recordState == 0">
                        <el-button slot="reference" type="danger" size="mini" round plain>批量勿访</el-button>
                    </el-popconfirm>
                </div>
                <el-table ref="multipleTable" :key="menuStatus" header-cell-class-name="tab-cell"
                    cell-class-name="tab-cell" border :data="list.data" v-loading="isLoading"
                    element-loading-text="数据正在查询中，请耐心等待"
                    @selection-change="selectionChange">
                    <el-table-column v-if="menuStatus && menuStatus == 1" fixed="left" type="selection"
                        width="55"></el-table-column>
                    <el-table-column prop="name" label="姓名" width="100" fixed="left">
                        <template slot-scope="scope">
                            <router-link class="noline" target="_blank"
                                :to="{ name: 'Patient/User', query: { patientId: scope.row.patientId, t: 3, fid: scope.row.recordId, datasources: scope.row.datasources } }">
                                <span class="fc key">
                                    <i class="icon-fav small" v-if="scope.row.star == 1"></i>
                                    {{ scope.row.name }}
                                </span>
                            </router-link>
                        </template>
                    </el-table-column>
                    <el-table-column prop="age" label="年龄" width="80" v-if='menuStatus==1'></el-table-column>
                    <el-table-column prop="admissionNumber" label="住院号" width="140"
                        show-overflow-tooltip></el-table-column>
                    <el-table-column prop="inHospitalDepartment" label="科室"></el-table-column>
                    <el-table-column prop="inHospitalDiagnosis" label="入院诊断" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="hospitalBed" label="床号" width="130"></el-table-column>
                    <el-table-column prop="inpatientArea" label="病区" width="130"
                        show-overflow-tooltip></el-table-column>
                    <el-table-column v-if="menuStatus == 2 || menuStatus == 3 || subMenu == 1 || subMenu == 2"
                        prop="diseaseManager" label="疾病管理师" width="100"></el-table-column>
                    <el-table-column prop="mainDoctor" label="责任医师" width="100"></el-table-column>
                    <el-table-column prop="inHospitalDate" label="入院时间" width="120"
                        show-overflow-tooltip></el-table-column>
                    <el-table-column v-if="menuStatus == 2 || menuStatus == 3 || subMenu == 1" prop="manageDate"
                        label="分配时间" width="120" show-overflow-tooltip></el-table-column>
                    <el-table-column v-if="menuStatus == 3" prop="updateTime" label="结束管理时间" width="120"
                        show-overflow-tooltip></el-table-column>


                    <el-table-column
                        v-if="menuStatus == 2 || menuStatus == 3 || menuStatus == 4 || menuStatus == 5 || menuStatus == 11"
                        prop="outHospitalDate" label="出院时间" width="120" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span v-if="scope.row.outHospitalDate">{{ scope.row.outHospitalDate }}</span>
                            <span v-else>尚未出院</span>
                        </template>
                    </el-table-column>
                    <el-table-column v-if="menuStatus == 5" prop="notVisitTime" label="勿访时间" width="120"
                        show-overflow-tooltip></el-table-column>
                    <el-table-column v-if="menuStatus == 5" prop="notVisitUserName" label="勿访人" width="120"
                        show-overflow-tooltip></el-table-column>
                    <el-table-column v-if="menuStatus == 7 || menuStatus == 8" prop="applicationTime" label="申请时间"
                        width="120" show-overflow-tooltip></el-table-column>
                    <el-table-column v-if="menuStatus == 9 || menuStatus == 10" prop="publishTime" label="发布时间"
                        width="120" show-overflow-tooltip></el-table-column>
                    <el-table-column v-if="menuStatus == 11" prop="eduTime" label="完成时间" width="120"
                        show-overflow-tooltip></el-table-column>

                    <el-table-column prop="manageUserName" label="分配人" v-if="menuStatus == 6"
                        width="100"></el-table-column>
                    <el-table-column fixed="right" label="操作" width="160">
                        <template slot-scope="scope">
                            <div class="tab-action">
                                <el-tooltip content="查看" placement="top" :enterable="false">
                                    <router-link target="_blank"
                                        :to="{ name: 'Patient/User', query: { patientId: scope.row.patientId, t: 3, fid: scope.row.recordId, datasources: scope.row.datasources } }">
                                        <i class="icon-research"></i>
                                    </router-link>
                                </el-tooltip>
                                <el-tooltip content="分配疾病管理师" placement="top" :enterable="false">
                                    <i class="icon-assigning" @click="showDlg(scope.row)" v-if="menuStatus == 1"></i>
                                </el-tooltip>
                                <el-tooltip content="修改疾病管理师" placement="top" :enterable="false">
                                    <i class="icon-assigning" @click="showDlg(scope.row)" v-if="menuStatus == 2"></i>
                                </el-tooltip>
                                <el-tooltip content="回退" slot="reference" placement="top" :enterable="false">
                                    <i class="icon-sync" @click="openModal(scope.row)"
                                        v-if="filter.recordState != 0 && !subMenu"></i>
                                </el-tooltip>
                                <el-popconfirm confirmButtonText='确定' title="确定勿访吗？" @confirm="saveForm2(scope.row)">
                                    <el-tooltip content="勿访" slot="reference" placement="top" :enterable="false">
                                        <i class="icon-wufan" v-if="menuStatus == 1 || menuStatus == 2"></i>
                                    </el-tooltip>
                                </el-popconfirm>
                            </div>

                        </template>
                    </el-table-column>
                    <template v-if="menuStatus == 1" #empty>
                        <div style="text-align: center; padding: 20px;">
                            <el-icon>
                                <Warning />
                            </el-icon>
                            <p>未查询到数据 <span @click="goToPatient" class="toPatient">【查看原因】</span> </p>
                        </div>
                    </template>
                </el-table>
                <div class="pagination">
                    <el-row>
                        <el-col :span="12">
                            <div class="record">当前是第<span
                                    v-text="(filter.pageNumber - 1) * filter.pageSize + 1"></span>条至第<span
                                    v-text="Math.min(list.total, (filter.pageNumber - 1) * filter.pageSize + filter.pageSize)"></span>数据
                            </div>
                            <div class="record">总计<span v-text="list.total"></span>条记录</div>
                        </el-col>
                        <el-col :span="12" style="text-align: right;">
                            <el-pagination :disabled="isLoading" layout="sizes, prev, pager, next"
                                :page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]" prev-text="上一页" next-text="下一页"
                                :current-page="list.current" :page-size="filter.pageSize" :total="list.total"
                                @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>

        <el-dialog title="分配疾病管理师" width="530px" :visible.sync="dlg.active" :close-on-click-modal="false">
            <el-form ref="form" label-width="120px" :rules="dlg.rules" :model="form">
                <el-form-item label="疾病管理师" prop="diseaseManagerId">
                    <el-select size="small" filterable clearable placeholder="请选择" v-model="form.diseaseManagerId">
                        <el-option v-for="item in managerList" :key="item.id" :label="item.name"
                            :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button :loading="isLoading" @click="closeDlg">关 闭</el-button>
                <el-button type="primary" :loading="isLoading" @click="saveForm1">保 存</el-button>
            </div>
        </el-dialog>
        <BackModal v-if="backdata.active" :backdata="backdata" @closeDlg="closeDlg" />
    </div>
</template>

<script>
import api from '@/service/api.js';
import utils from '@/service/utils';
import mixin from '@/views/mixin';
import dayjs from 'dayjs';
import BackModal from './components/backModal.vue';
export default {
    components: {
        BackModal
    },
    mixins: [mixin],
    data() {
        return {
            isExpanded: false,
            dlg: {
                active: false,
                rules: {
                    diseaseManagerId: { required: true, message: '请选择疾病管理师' }
                }
            },
            list: {
                current: 1,
                total: 0,
                pageSize: 0,
                data: null
            },
            filter: {
                name: '',
                cardNum: '',
                inHospitalDepartmentId: '',
                diseaseManagerId: '',
                inHospitalDiagnosis: '',
                recordState: null,//管理状态(0待分配，1管理中，2已结束，3已过期，4勿访)
                orderCondition: null,//1入院时间 2床号 3出院时间 4分配时间 5勿访时间
                orderRule: 2,//1正序 2倒序
                pageNumber: 1,
                pageSize: 10,
                evalScoreTypes: [],
                evalScoreTypeRelation: 1,
                checkedEval: [],
                admissionNumber: ''
            },

            form: {
                id: 0,
                diseaseManager: '',
                diseaseManagerId: '',
                ids: [],
                recordState: 0
            },

            deptList: [],
            managerList: [],
            backdata: {
                active: false,
                data: {},
                type: 1
            },
            menuStatus: null,
            subMenu: null,
            orderConditionList: [],
            orderRuleList: [
                { id: 1, name: '正序' },
                { id: 2, name: '倒序' }
            ],
            titleData: {
                1: '待管理',
                2: '管理中',
                3: '已完成',
                4: '已过期',
                5: '勿访',
                6: '待评估',
                7: '已评估',
                8: '待发布',
                9: '已发布',
                10: '待宣教',
                11: '出院前准备'
            },
            menuData: {
                1: '院中评估',
                2: '六大处方',
                3: '处方宣教'
            },
            selectData: {
                inHospital: {
                    label: '入院评估',
                    type: 4,
                    options: {
                        left: [
                            { name: 'BMI', id: 1 },
                            { name: '血压', id: 2 }
                        ],
                        right: [
                            [
                                { name: '体重过低', id: 1 },
                                { name: '体重正常', id: 2 },
                                { name: '超重', id: 3 },
                                { name: '肥胖', id: 4 },
                                { name: '未完成', id: 9 }
                            ],
                            [
                                { name: '血压偏低', id: 1 },
                                { name: '血压正常', id: 2 },
                                { name: '正常高值血压', id: 3 },
                                { name: '高血压一级', id: 4 },
                                { name: '高血压二级', id: 5 },
                                { name: '未完成', id: 9 }
                            ]
                        ]
                    }
                },
                diet: {
                    label: '饮食评估',
                    type: 6,
                    options: {
                        left: [
                            { name: '膳食能量', id: 1 },
                            { name: '膳食结构', id: 2 }
                        ],
                        right: [
                            [
                                { name: '不足', id: 1 },
                                { name: '合理', id: 2 },
                                { name: '超标', id: 3 },
                                { name: '未完成', id: 9 }
                            ],
                            [
                                { name: '较均衡', id: 1 },
                                { name: '轻度不均衡', id: 2 },
                                { name: '明显不均衡', id: 3 },
                                { name: '未完成', id: 9 }
                            ]
                        ]
                    }
                },
                sport: {
                    label: '运动评估',
                    type: 5,
                    options: [{ name: '低风险', id: 1 }, { name: '中风险', id: 2 }, { name: '高风险', id: 3 }, { name: '未完成', id: 9 }]
                },
                sleep: {
                    type: 7,
                    label: '睡眠评估',
                    options: [{ name: '低风险', id: 1 }, { name: '高风险', id: 2 }, { name: '未完成', id: 9 }]
                },
                psychology: {
                    type: 2,
                    label: '心理评估',
                    options: [{ name: '正常', id: 1 }, { name: '异常', id: 2 }, { name: '未完成', id: 9 }]
                },
                medicine: {
                    label: '中医评估',
                    type: 3,
                    options: [{ name: '平和', id: 0 }, { name: '非平和', id: 1 }, { name: '未完成', id: 9 }]
                },
                expect: {
                    label: '就医期望值',
                    type: 9,
                    options: [{ name: '正常', id: 1 }, { name: '偏高', id: 2 }, { name: '过高', id: 3 }, { name: '未完成', id: 9 }]
                },
                confidence: {
                    label: '就医信心度',
                    type: 12,
                    options: [{ name: '正常', id: 1 }, { name: '偏低', id: 2 }, { name: '过低', id: 3 }, { name: '未完成', id: 9 }]
                },
                inHospitalDisease: {
                    label: '入院疾病认知度',
                    type: 8,
                    options: [{ name: '0-59分', id: 0 }, { name: '60-100分', id:1 }, { name: '未完成', id: 9 }]
                },
                outHospitalDisease: {
                    label: '出院疾病认知度',
                    type: 10,
                    options: [{ name: '0-59分', id: 0 }, { name: '60-100分', id:1 }, { name: '未完成', id: 9 }]
                },
                satisfactionSurvey: {
                    label: '满意度调查',
                    type: 11,
                    options: [{ name: '已完成', id: 1 },{ name: '未完成', id: 9 }]
                },
            },
            mainList: []

        }
    },
    created() {

        let query = this.$route.query;
        if (query.status) {
            this.$set(this, 'menuStatus', Number(query.status));
        }
        if (query.menus) {
            this.subMenu = Number(query.menus)
        }
        // 获取 科室下拉
        api.getDeptDropdown({ departmentType: 0 }).then((res) => {
            if (res.code == 1000 && res.data) {
                this.deptList = res.data;
            }
        })
        // 获取 疾病管理师下拉
        api.getComboboxUserList({ roleId: 3 }).then((res) => {
            if (res.code == 1000 && res.data) {
                this.managerList = res.data;
            }
        })
        // 获取 责任医师下拉
        api.getComboboxUserList({ roleId: 2 }).then((res) => {
            if (res.code == 1000 && res.data) {
                this.mainList = res.data;
            }
        })
        if (query.depId) {
            this.filter.inHospitalDepartmentId = parseInt(query.depId);
        }
        if (query.date) {
            this.filter.inHospitalDateStart = dayjs(query.date[0]).format('YYYY-MM-DD 00:00:00')
            this.filter.inHospitalDateEnd = dayjs(query.date[1]).format('YYYY-MM-DD 23:59:59');
            this.filter.inDate = [this.filter.inHospitalDateStart, this.filter.inHospitalDateEnd];
        }

        this.$watch(
            () => this.$route.query, // 监听的对象是 $route.query
            (newQuery, oldQuery) => {
                this.reset(newQuery);
                // this.loadList();
            }
        );
        this.switchfilter()
        this.loadList();
    },
    mounted() {
        // 监听页面显示隐藏
        document.addEventListener('visibilitychange', this.handleVisiable);
    },
    destroyed() {
        document.removeEventListener('visibilitychange', this.handleVisiable)
    },
    methods: {
        handleVisiable(e) {
            // 关闭新开页面，回到列表页，刷新列表数据
            if (e.target.visibilityState == "visible") {
                this.loadList()
            }
        },
        reset(newQuery) {
            // 管理中
            // this.menuStatus=Number(newQuery.status)
            this.$set(this, 'menuStatus', Number(newQuery.status));
            this.subMenu = Number(newQuery.menus);
            this.filter = {
                name: '',
                cardNum: '',
                inHospitalDepartmentId: '',
                diseaseManagerId: '',
                recordState: null,
                orderCondition: null,
                orderRule: 2,//1正序 2倒序
                pageNumber: 1,
                pageSize: 10,
                evalScoreTypes: [],
                checkedEval: [],
                evalScoreTypeRelation: 1,
                publishStatus: null,
                eduStatus: null,
                applicationStatus: null
            }
            this.isExpanded = false;
            this.switchfilter();
            this.loadList();
        },
        switchfilter() {
            switch (this.menuStatus) {
                case 6:
                    this.filter.applicationStatus = 0;
                    break;
                case 8:
                    this.filter.publishStatus = 1;
                    break;
                case 10:
                    this.filter.eduStatus = 1;
                    break;
            }
            switch (this.menuStatus) {
                case 1:
                    this.filter = {
                        ...this.filter,
                        recordState: 0,
                        orderCondition: 1,

                    }
                    this.orderConditionList = [
                        { id: 1, name: '入院时间' },
                        { id: 2, name: '床号' },
                    ]
                    break;
                case 2: case 6: case 8: case 10:
                    this.filter = {
                        ...this.filter,
                        recordState: 1,
                        orderCondition: 4,
                    }
                    this.orderConditionList = [
                        { id: 1, name: '入院时间' },
                        { id: 2, name: '床号' },
                        { id: 3, name: '出院时间' },
                        { id: 4, name: '分配时间' },
                    ]
                    break;
                case 3:
                    this.filter = {
                        ...this.filter,
                        recordState: 2,
                        orderCondition: 6,
                    }
                    this.orderConditionList = [
                        { id: 1, name: '入院时间' },
                        { id: 2, name: '床号' },
                        { id: 3, name: '出院时间' },
                        { id: 4, name: '分配时间' },
                        { id: 6, name: '结束管理时间' },
                    ]
                    break;
                case 4:
                    this.filter = {
                        ...this.filter,
                        recordState: 3,
                        orderCondition: 3,
                    }
                    this.orderConditionList = [
                        { id: 1, name: '入院时间' },
                        { id: 2, name: '床号' },
                        { id: 3, name: '出院时间' },
                    ]
                    break;
                case 5:
                    this.filter = {
                        ...this.filter,
                        recordState: 4,
                        orderCondition: 5,
                    }
                    this.orderConditionList = [
                        { id: 1, name: '入院时间' },
                        { id: 2, name: '床号' },
                        { id: 3, name: '出院时间' },
                        { id: 5, name: '勿访时间' }
                    ]
                    break;
                case 7:
                    this.filter = {
                        ...this.filter,
                        recordState: 1,
                        orderCondition: 4,
                        applicationStatus: 1
                    }
                    this.orderConditionList = [
                        { id: 1, name: '入院时间' },
                        { id: 2, name: '床号' },
                        { id: 3, name: '出院时间' },
                        { id: 4, name: '分配时间' },
                        { id: 7, name: '申请时间' },
                    ]
                    break;
                case 9:
                    this.filter = {
                        ...this.filter,
                        recordState: 1,
                        orderCondition: 4,
                        publishStatus: 2
                    }
                    this.orderConditionList = [
                        { id: 1, name: '入院时间' },
                        { id: 2, name: '床号' },
                        { id: 3, name: '出院时间' },
                        { id: 4, name: '分配时间' },
                        { id: 8, name: '发布时间' },
                    ]
                    break;
                case 11:
                    this.filter = {
                        ...this.filter,
                        recordState: 1,
                        orderCondition: 4,
                        eduStatus: 2
                    }
                    this.orderConditionList = [
                        { id: 1, name: '入院时间' },
                        { id: 2, name: '床号' },
                        { id: 3, name: '出院时间' },
                        { id: 4, name: '分配时间' },
                        { id: 9, name: '完成时间' },
                    ]
                    break;
            }
        },
        async loadList() {
            this.isLoading = true;
            // if (this.filter.checkedEval.length > 0) {
            this.filter.evalScoreTypes = JSON.stringify(this.filter.checkedEval)
            // }
            let res = await api.getHospitalPatientList(this.filter);
            if (res.code == 500) { return this.$router.push({ name: 'Login', query: { r: location.href } }); }

            this.list.total = +res.total;
            this.list.current = this.filter.pageNumber;
            this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
            if (res.data) {
                res.data.forEach((item) => {
                    item.inHospitalDate = dayjs(item.inHospitalDate).format('YYYY-MM-DD HH:mm:ss');
                    item.recordId = item.id;
                    item.id = item.ihdId;
                    let inpatientArea = [];
                    if (item.inpatientArea) { inpatientArea.push(item.inpatientArea) }
                    if (item.inpatientWard) { inpatientArea.push(item.inpatientWard) }
                    if (item.hospitalBed) { item.hospitalBed += "床" }
                    item.inpatientArea = inpatientArea.join('-');
                })
                this.list.data = res.data;
            }
            this.isLoading = false;
        },
        openModal(item) {
            this.backdata.active = true;
            this.backdata.data = item;
            this.backdata.type = this.menuStatus;
        },

        toggleCollapse() {
            this.isExpanded = !this.isExpanded;
        },
        resetForm() {
            Object.keys(this.selectData).forEach(key => {
                this.filter[key + 'type'] = '';
                this.filter[key + 'level'] = '';
                this.filter.evalScoreTypes = []
                this.filter.checkedEval = [];
                delete this.filter[key + 'type']
                delete this.filter[key + 'level']
            })
            this.filter.evalScoreTypeRelation = 1;
            this.loadList()
        },
        // 过滤条件 更改
        handleFilter(key, val, itemKey) {
            let existingEvalScoreType
            switch (key) {
                case 2:
                    if (val === null || val === undefined || val === '') {
                        this.filter.checkedEval = this.filter.checkedEval.filter(
                            (scoreType) => scoreType.type !== this.selectData[itemKey].type
                        );
                    } else {
                        existingEvalScoreType = this.filter.checkedEval.find(
                            (scoreType) => scoreType.type === this.selectData[itemKey].type
                        );
                        if (existingEvalScoreType) {
                            // 如果已存在对应项，更新值
                            if (this.selectData[itemKey].type === 4 || this.selectData[itemKey].type === 6) {
                                if (this.filter[itemKey + 'type'] == 1 && this.filter[itemKey + 'level']) {
                                    existingEvalScoreType.evalLevel = this.filter[itemKey + 'level'];
                                    existingEvalScoreType.evalLevel2 = null;
                                } else if (this.filter[itemKey + 'type'] == 2 && this.filter[itemKey + 'level']) {
                                    existingEvalScoreType.evalLevel2 = this.filter[itemKey + 'level'];
                                    existingEvalScoreType.evalLevel = null;
                                }
                            } else {
                                existingEvalScoreType.evalLevel = this.filter[itemKey + 'type'];
                                existingEvalScoreType.evalLevel2 = null;
                            }
                        } else {
                            // 如果不存在对应项，添加新值
                            if (this.selectData[itemKey].type === 4 || this.selectData[itemKey].type === 6) {
                                if (this.filter[itemKey + 'type'] == 1 && this.filter[itemKey + 'level']) {
                                    this.filter.checkedEval.push({
                                        'type': this.selectData[itemKey].type,
                                        'evalLevel': this.filter[itemKey + 'level'],
                                        'evalLevel2': null,
                                    });
                                } else if (this.filter[itemKey + 'type'] == 2 && this.filter[itemKey + 'level']) {
                                    this.filter.checkedEval.push({
                                        'type': this.selectData[itemKey].type,
                                        'evalLevel': null,
                                        'evalLevel2': this.filter[itemKey + 'level'],
                                    });
                                }
                            } else {
                                this.filter.checkedEval.push({
                                    'type': this.selectData[itemKey].type,
                                    'evalLevel': this.filter[itemKey + 'type'],
                                    'evalLevel2': null,
                                });

                            }
                        }

                    }


                    break;
                case 'inDate'://入院时间
                    if (this.filter.inDate) {
                        this.filter.inHospitalDateStart = dayjs(this.filter.inDate[0]).format('YYYY-MM-DD 00:00:00');
                        this.filter.inHospitalDateEnd = dayjs(this.filter.inDate[1]).format('YYYY-MM-DD 23:59:59');
                    } else {
                        this.filter.inHospitalDateStart = '';
                        this.filter.inHospitalDateEnd = '';
                    }
                    break;
                case 'manageDate'://分配时间
                    if (this.filter.manageDate) {
                        this.filter.manageDateStart = dayjs(this.filter.manageDate[0]).format('YYYY-MM-DD 00:00:00');
                        this.filter.manageDateEnd = dayjs(this.filter.manageDate[1]).format('YYYY-MM-DD 23:59:59');
                    } else {
                        this.filter.manageDateStart = '';
                        this.filter.manageDateEnd = '';
                    }
                    break;
                case 'finishDate'://结束管理时间
                    if (this.filter.finishDate) {
                        this.filter.endInHospitalTimeStart = dayjs(this.filter.finishDate[0]).format('YYYY-MM-DD 00:00:00');
                        this.filter.endInHospitalTimeEnd = dayjs(this.filter.finishDate[1]).format('YYYY-MM-DD 23:59:59');
                    } else {
                        this.filter.endInHospitalTimeStart = '';
                        this.filter.endInHospitalTimeEnd = '';
                    }
                    break;
                case 'outDate'://出院时间
                    if (this.filter.outDate) {
                        this.filter.outHospitalDateStart = dayjs(this.filter.outDate[0]).format('YYYY-MM-DD 00:00:00');
                        this.filter.outHospitalDateEnd = dayjs(this.filter.outDate[1]).format('YYYY-MM-DD 23:59:59');
                    } else {
                        this.filter.outHospitalDateStart = '';
                        this.filter.outHospitalDateEnd = '';
                    }
                    break;
                case 'dispenseDate'://勿访时间
                    if (this.filter.dispenseDate) {
                        this.filter.notVisitTimeStart = dayjs(this.filter.dispenseDate[0]).format('YYYY-MM-DD 00:00:00');
                        this.filter.notVisitTimeEnd = dayjs(this.filter.dispenseDate[1]).format('YYYY-MM-DD 23:59:59');
                    } else {
                        this.filter.notVisitTimeStart = '';
                        this.filter.notVisitTimeEnd = '';
                    }
                    break;
                case 'applicationTime'://申请时间
                    if (this.filter.applicationTime) {
                        this.filter.applicationTimeStart = dayjs(this.filter.applicationTime[0]).format('YYYY-MM-DD 00:00:00');
                        this.filter.applicationTimeEnd = dayjs(this.filter.applicationTime[1]).format('YYYY-MM-DD 23:59:59');
                    } else {
                        this.filter.applicationTimeStart = '';
                        this.filter.applicationTimeEnd = '';
                    }
                    break;
                case 'eduTime'://完成宣教时间
                    if (this.filter.eduTime) {
                        this.filter.endInHospitalTimeStart = dayjs(this.filter.eduTime[0]).format('YYYY-MM-DD 00:00:00');
                        this.filter.endInHospitalTimeEnd = dayjs(this.filter.eduTime[1]).format('YYYY-MM-DD 23:59:59');
                    } else {
                        this.filter.endInHospitalTimeStart = '';
                        this.filter.endInHospitalTimeEnd = '';
                    }
                    break;
                case 'publishTime'://发布时间
                    if (this.filter.publishTime) {
                        this.filter.publishTimeStart = dayjs(this.filter.publishTime[0]).format('YYYY-MM-DD 00:00:00');
                        this.filter.publishTimeEnd = dayjs(this.filter.publishTime[1]).format('YYYY-MM-DD 23:59:59');
                    } else {
                        this.filter.publishTimeStart = '';
                        this.filter.publishTimeEnd = '';
                    }
                    break;
            }
            this.filter.pageNumber = 1;
            this.loadList();
        },
        handleSizeChange(v) {
            this.filter.pageSize = v;
            this.filter.pageNumber = 1;
            this.loadList();
        },
        handleCurrentChange(v) {
            this.filter.pageNumber = v;
            this.loadList();
        },
        showDlg(item) {
            if (item && item.id > 0) {
                this.dlg.active = true;
                this.form.id = +item.ihdId;//分配要用院中id
                this.form.diseaseManagerId = item.diseaseManagerId || '';
            } else {
                if (this.multipleSelection.length == 0) {
                    return this.$message.warning('未选择任何数据');
                }
                this.dlg.active = true;
                this.form.id = 0;
                this.form.diseaseManagerId = '';
                this.$nextTick(() => {
                    this.$refs['form'].resetFields();
                });
            }
        },
        closeDlg(data) {
            this.dlg.active = false;
            this.backdata = {
                active: false,
                data: {},
                type: 1
            }
            if (data && data == 'sucess') {
                this.loadList();
            }
        },
        //   分配疾病管理师
        async saveForm1() {
            let res;
            this.$refs['form'].validate(async (valid) => {
                if (valid) {
                    let user = this.managerList.find((item) => { if (item.id == this.form.diseaseManagerId) { return item; } });
                    this.form.diseaseManager = user.name;
                    this.form.recordState = 1;
                    if (this.form.id > 0) {
                        this.form.ids = this.form.id;
                    } else {
                        // 批量
                        this.form.ids = this.multipleSelection.join(',');
                    }
                    this.isLoading = true;
                    res = await api.updateHospitalPatientState(this.form);
                    this.isLoading = false;
                    if (res.code != 1000) {
                        return this.$message.error(res.message);
                    }
                    this.closeDlg();
                    this.$message.success('保存成功');
                    this.loadList();
                }
            })
        },
        // 勿访
        async saveForm2(item) {
            let res;
            this.form.diseaseManager = '';
            this.form.diseaseManagerId = '';
            this.form.recordState = 4;
            if (item && item.id > 0) {
                this.form.ids = item.ihdId;//要用院中id
            } else {
                // 批量
                if (this.multipleSelection.length == 0) {
                    return this.$message.warning('未选择任何数据');
                }
                this.form.ids = this.multipleSelection.join(',');
            }
            this.isLoading = true;
            res = await api.updateHospitalPatientState(this.form);
            this.isLoading = false;
            if (res.code != 1000) {
                return this.$message.error(res.message);
            }
            this.closeDlg();
            this.$message.success('保存成功');
            this.loadList();
        },
        async saveForm3(item) {
            // 回退
            let res;
            this.isLoading = true;
            res = await api.rollbackrecordState({ ihdid: item.ihdId });
            this.isLoading = false;
            if (res.code != 1000) {
                return this.$message.error(res.message);
            }
            this.$message.success('保存成功');
            this.loadList();
        },
        exportReport() {
            this.filter.pageSize = this.list.total;
            let url = api.exportListInHospitalReport(this.filter);
            const tempLink = document.createElement('a');
            tempLink.style.display = 'none';
            tempLink.href = url;
            tempLink.target = '_blank';
            document.body.appendChild(tempLink);
            tempLink.click()
            document.body.removeChild(tempLink);
            this.filter.pageSize = 10;

        },
        goToPatient() {
            if (this.menuStatus !== 1) return;
            const { admissionNumber, name, cardNum } = this.filter;
            const query = { dataType: 0, ...(admissionNumber && { admissionNumber }), ...(name && !admissionNumber && { name }), ...(cardNum && !admissionNumber && !name && { cardNum }) };

            this.$router.push({ name: 'Common/FindPatient', query });
        }
    }
}
</script>

<style lang="less" scoped>
@import '@/assets/style/var';

.def-key {
    border: none !important;
    margin-bottom: 0 !important;
}

.flr {
    margin-left: 10px;
}

.more-key {
    padding-top: 10px;
    margin-top: 12px;
    border-top: 1px solid #ebeef5;
    padding: 20px 30px 0;

    .more-item {
        margin-top: 20px;
        display: flex;
        flex-wrap: wrap;
        padding: 0 8%;

        ::v-deep .el-form-item {
            width: 50%;

            .el-input__icon {
                height: 78%;
            }
        }

        .reset {
            width: 100%;

            ::v-deep .el-form-item__content {
                float: right;
            }
        }
    }
}
</style>